/**
 * @typedef {typeof defaultLiveOdds} LiveMatchModel
 */
/**
 * Mapper for home and away sets
 * @param {{SetScores:string}} data api data
 * @param {boolean} home map to home or away
 */
const mapSets = (data) => {
  const setsString = data.SetScores || '';
  const setsData = setsString.split('|');
  const setScores = Array(10).fill('0:0').map((sc, i) => setsData[i] || sc);
  const emptySets = Array(10).fill('-:-').map((sc, i) => setsData[i] || sc);
  const currentSet = [emptySets[setsData.length - 1]];

  return { setScores, emptySets, currentSet };
};
/**
 * Map and convert to number sets scores by team
 * @param {string[]} sets
 * @param {boolean} home
 */
const mapSetsByTeamsNumber = (sets, home) => sets.map(sc => +sc.split(':')[home ? 0 : 1]);
/**
 * Map sets scores by team
 * @param {string[]} sets
 * @param {boolean} home
 */
const mapSetsByTeamsString = (sets, home) => sets.map(sc => sc.split(':')[home ? 0 : 1]);
/**
 * Mapper for home and away stats
 * @param data api data
 * @param {LiveMatchModel} liveOddsData
 * @param {number[]} sets sets scores number
 * @param {string[]} es set scores string
 * @param {string[]} cs current set
 * @param {boolean} home map to home or away
 */
const mapStats = (data, liveOddsData, sets, es, cs, home) => ({
  /**
   * @type {number}
   */
  corners: home ? data.CornersHome : data.CornersAway,
  /**
   * @type {number}
   */
  yellowCards: home ? data.YellowCardHome : data.YellowCardAway,
  /**
   * @type {number}
   */
  redCards: home ? data.RedCardsHome : data.RedCardsAway,
  /**
   * @type {number}
   */
  suspend: home ? data.SuspendHome : data.SuspendAway,
  /**
   * @type {number}
   */
  batter: home ? data.BatterHome : data.BatterAway,
  /**
   * @type {string}
   */
  name: home ? data.HomeTeam : data.AwayTeam,
  /**
   * @type {string}
   */
  // currentScore: home ? liveOddsData.score.home : liveOddsData.score.away,
  /**
   * @type {string[]}
   */
  sets: es,
  /**
   * @type {number[]}
   */
  setsNumber: sets,
  totalScore: sets.reduce((l, r) => l + r, 0),
  currentSet: cs[0],
  points: (data.GameScore || '-:-').split(':')[home ? 0 : 1],
});
/**
 * Generate live tracker title from liveHub data
 * @param {defaultLiveOdds} lod liveHub data
 */
// const generateTitle = (lod) => `${lod.categoryName}${lod.categoryName && lod.tournamentName ? ' - ' : ''}${lod.tournamentName}`;
const generateTitle = (data) => `${data.CategoryName}${data.CategoryName && data.TournamentName ? ' - ' : ''}${data.TournamentName}${data.VenueName ? ',' + data.VenueName : ''}`;

const defaultLiveOdds = {
  score: {
    home: '-',
    away: '-',
  },
  tournamentName: '',
  categoryName: '',
};
const HOME = true;
const AWAY = false;
export default class LiveTrackerModel {
  constructor(data, liveOddsData = defaultLiveOdds) {
    /**
     * @type {string}
     */
    this.betRadarId = data.BetRadarID;
    /**
     * @type {number}
     */
    this.sportId = data.SportID;
    /**
     * @type {string}
     */
    this.feedProvider = data.FPC;
    /**
     * @type {string}
     */
    this.score = data.Score;
    /**
     * @type {number}
     */
    this.balls = data.Balls;
    /**
     * @type {string}
     */
    this.bases = data.Bases;
    /**
     * @type {string}
     */
    this.gameScore = data.GameScore;
    /**
     * @type {string}
     */
    this.matchTime = data.MatchTime;
    /**
     * @type {string}
     */
    this.matchStatus = data.MatchStatus;
    /**
     * @type {number}
     */
    this.outs = data.Outs;
    /**
     * @type {number}
     */
    this.position = data.Position;
    /**
     * @type {number}
     */
    this.possession = data.Possession;
    /**
     * @type {number}
     */
    this.strikes = data.Strikes;
    /**
     * maybe boolean
     * @type {boolean }
     */
    this.tieBreak = data.TieBreak;
    /**
     * @type {number}
     */
    this.try = data.Try;
    /**
     * @type {number}
     */
    this.yards = data.Yards;

    // this.trackerTitle = generateTitle(liveOddsData);
    this.trackerTitle = generateTitle(data);

    const { setScores, emptySets, currentSet } = mapSets(data);
    this.homeStats = mapStats(data,
      liveOddsData,
      mapSetsByTeamsNumber(setScores, HOME),
      mapSetsByTeamsString(emptySets, HOME),
      mapSetsByTeamsString(currentSet, HOME),
      HOME);
    this.awayStats = mapStats(data,
      liveOddsData,
      mapSetsByTeamsNumber(setScores, AWAY),
      mapSetsByTeamsString(emptySets, AWAY),
      mapSetsByTeamsString(currentSet, AWAY),
      AWAY);
  }
}
